/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import { Crate } from '@piwikpro/platform';
import { RouterService } from './RouterService';
import { routerReducer } from './reducers/routerReducer';

@Crate({
  name: 'RouterCrate',
  services: [
    { name: 'router', provide: RouterService },
  ],
  reducers: {
    router: routerReducer,
  },
  reduxMiddleware: [],
})
export class RouterCrate { }
